<template>
    <div>
        <div class="main-container">
            <KidHeader :profileId="profileId" :serialNumber="serialNumber" />

            <!-- Back nav -->
            <div class="req-back">
                <a class="req-back__link" href="javascript:void(0)"
                    @click="$router.push({ path: '/kids-device', query: { profileId: profileId } })">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M19 12H5M5 12l7 7M5 12l7-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Home
                </a>
            </div>

            <!-- Page header -->
            <div class="ct-page-header">
                <div>
                    <h1 class="ct-page-header__title">Contacts</h1>
                    <p class="ct-page-header__sub">{{ contacts.length }} contact{{ contacts.length !== 1 ? 's' : '' }} saved</p>
                </div>
                <div class="ct-page-header__actions">
                    <button class="ct-requests-btn" @click="openRequestsModal()" v-if="totalPendingRequests > 0">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="ct-requests-btn__badge">{{ totalPendingRequests > 99 ? '99+' : totalPendingRequests }}</span>
                    </button>
                    <button class="ct-add-btn" @click="openAddModal()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Add
                    </button>
                </div>
            </div>

            <!-- Wingio dialer disabled banner -->
            <div class="ct-dialer-banner" v-if="wingioDialerLoaded && !settings.enableWingioDialer">
                <div class="ct-dialer-banner__icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.42 19.42 0 0 1 4.91 8.84a19.79 19.79 0 0 1-3.07-8.64A2 2 0 0 1 3.82 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.8 9.9a16 16 0 0 0 2.89 3.41zM23 1l-6 6M17 1l6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="ct-dialer-banner__body">
                    <span class="ct-dialer-banner__title">Wingio Dialer is disabled</span>
                    <span class="ct-dialer-banner__sub">Contact restrictions are inactive. <a href="javascript:void(0)" @click="openSettingsModal()" class="ct-dialer-banner__link">Enable in Settings</a></span>
                </div>
            </div>

            <!-- Quick actions -->
            <div class="ct-quick-actions">
                <button class="ct-quick-btn" v-if="hasChatAccess" @click="$router.push({ path: '/chats', query: { profileId, serialNumber } })">
                    <div class="ct-quick-btn__icon ct-quick-btn__icon--blue">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <span>View SMS</span>
                </button>
                <button class="ct-quick-btn" v-if="hasChatAccess" @click="$router.push({ path: '/call-history', query: { profileId, serialNumber } })">
                    <div class="ct-quick-btn__icon ct-quick-btn__icon--green">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.81a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <span>Call History</span>
                </button>
                <button class="ct-quick-btn" @click="openRequestsModal()">
                    <div class="ct-quick-btn__icon ct-quick-btn__icon--orange">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
                            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                        </svg>
                    </div>
                    <span>Requests</span>
                    <span class="ct-quick-btn__badge" v-if="totalPendingRequests > 0">{{ totalPendingRequests }}</span>
                </button>
                <button class="ct-quick-btn" @click="openSettingsModal()">
                    <div class="ct-quick-btn__icon ct-quick-btn__icon--purple">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
                            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" stroke-width="1.8"/>
                        </svg>
                    </div>
                    <span>Settings</span>
                </button>
                <button class="ct-quick-btn" v-if="isContactPickerSupported" @click="importFromPhone()" :disabled="importing">
                    <div class="ct-quick-btn__icon ct-quick-btn__icon--teal">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
                            <path d="M16 11l2 2 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <span>{{ importing ? 'Importing...' : 'Import' }}</span>
                </button>
            </div>

            <!-- Contacts list -->
            <div :style="{ width: '100%', 'text-align': 'left' }" :class="{ 'ct-lockout': wingioDialerLoaded && !settings.enableWingioDialer }">

                <!-- Empty -->
                <div class="ct-empty" v-if="contacts.length === 0">
                    <div class="ct-empty__icon">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round"/>
                            <circle cx="12" cy="7" r="4" stroke="#d1d5db" stroke-width="1.5"/>
                        </svg>
                    </div>
                    <span class="ct-empty__title">No contacts yet</span>
                    <span class="ct-empty__sub">Add your first contact to get started</span>
                    <button class="ct-add-btn ct-add-btn--full" @click="openAddModal()">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Add First Contact
                    </button>
                </div>

                <!-- List -->
                <div class="ct-list" v-else>
                    <div class="ct-contact-card" v-for="contact in contacts" :key="contact._id"
                        :class="{ 'ct-contact-card--emergency': contact.isEmergency }">
                        <div class="ct-contact-card__avatar">
                            <img v-if="contact.imageUrl" :src="contact.imageUrl" />
                            <span v-else>{{ getInitials(contact.name) }}</span>
                        </div>
                        <div class="ct-contact-card__body">
                            <div class="ct-contact-card__name-row">
                                <span class="ct-contact-card__name">{{ contact.name }}</span>
                                <span class="ct-emergency-pill" v-if="contact.isEmergency">
                                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    Emergency
                                </span>
                            </div>
                            <a :href="'tel:' + contact.phone" class="ct-contact-card__phone">{{ contact.phone }}</a>
                            <span class="ct-contact-card__notes" v-if="contact.notes">{{ contact.notes }}</span>
                        </div>
                        <div class="ct-contact-card__actions">
                            <button class="ct-contact-btn ct-contact-btn--edit" @click="openEditModal(contact)">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <button class="ct-contact-btn ct-contact-btn--delete" @click="openDeleteModal(contact._id)">
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                    <polyline points="3 6 5 6 21 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10 11v6M14 11v6M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="last-updated" style="padding: 16px 0 24px;">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                    <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
                Tap any contact to call directly
            </div>

            <!-- ── Add Contact Modal ── -->
            <div class="ct-modal-overlay" v-if="showAddModal" @click.self="showAddModal = false">
                <div class="ct-modal">
                    <div class="ct-modal__header">
                        <div class="ct-modal__header-icon ct-modal__header-icon--blue">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
                                <path d="M16 11l2 2 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <div class="ct-modal__title">Add Contact</div>
                            <div class="ct-modal__sub">Add a new contact to this device</div>
                        </div>
                        <button class="ct-modal__close" @click="showAddModal = false">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="ct-modal__body">
                        <div class="ct-field">
                            <label class="ct-field__label">Full Name *</label>
                            <input type="text" class="ct-field__input" v-model="addForm.name"
                                placeholder="e.g. Mom, Dad, Grandma"
                                @input="onAddNameInput($event.target.value)" />
                        </div>
                        <div class="ct-field">
                            <label class="ct-field__label">Phone Number *</label>
                            <input type="tel" class="ct-field__input" v-model="addForm.phone" placeholder="Enter phone number" />
                        </div>
                        <div class="ct-field">
                            <label class="ct-field__label">Notes <span class="ct-optional">(optional)</span></label>
                            <input type="text" class="ct-field__input" v-model="addForm.notes" placeholder="e.g. Call after school" maxlength="100" />
                        </div>
                        <div class="ct-field">
                            <label class="ct-field__label">Photo <span class="ct-optional">(optional)</span></label>
                            <div class="ct-photo-row">
                                <div class="ct-photo-row__thumb">
                                    <img v-if="addForm.previewUrl" :src="addForm.previewUrl" />
                                    <span v-else>{{ getInitials(addForm.name) }}</span>
                                </div>
                                <label class="ct-photo-row__btn">
                                    {{ addForm.previewUrl ? 'Change photo' : 'Choose photo' }}
                                    <input type="file" class="ct-sr-only" accept="image/*" @change="handleAddFileUpload" />
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Pinned: stays visible, never scrolls -->
                    <div class="ct-emergency-pinned" :class="{ 'ct-emergency-pinned--on': addForm.isEmergency }">
                        <div class="ct-emergency-pinned__icon">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="ct-emergency-pinned__text">
                            <span class="ct-emergency-pinned__title">Emergency contact</span>
                            <span class="ct-emergency-pinned__sub" v-if="addForm.autoDetected">Turned on because this looks like family. You can turn it off.</span>
                            <span class="ct-emergency-pinned__sub" v-else>Can always call and message, even when restrictions are on</span>
                        </div>
                        <label class="kid-action-switch kid-action-switch--amber">
                            <input type="checkbox" v-model="addForm.isEmergency" aria-label="Emergency contact"
                                @change="markEmergencyTouched(addForm)" />
                            <span class="kid-action-switch__track"></span>
                        </label>
                    </div>
                    <div class="ct-modal__footer">
                        <button class="ct-modal__cancel" @click="showAddModal = false">Cancel</button>
                        <button class="ct-modal__confirm" @click="addContact()" :disabled="isAdding">
                            <span v-if="isAdding"><i class="fa fa-spinner fa-spin"></i></span>
                            <span v-else>Add Contact</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- ── Edit Contact Modal ── -->
            <div class="ct-modal-overlay" v-if="showEditModal" @click.self="showEditModal = false">
                <div class="ct-modal">
                    <div class="ct-modal__header">
                        <div class="ct-modal__header-icon ct-modal__header-icon--purple">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <div class="ct-modal__title">Edit Contact</div>
                            <div class="ct-modal__sub">Update contact information</div>
                        </div>
                        <button class="ct-modal__close" @click="showEditModal = false">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="ct-modal__body">
                        <div class="ct-field">
                            <label class="ct-field__label">Full Name *</label>
                            <input type="text" class="ct-field__input" v-model="editForm.name" placeholder="Enter full name" />
                        </div>
                        <div class="ct-field">
                            <label class="ct-field__label">Phone Number *</label>
                            <input type="tel" class="ct-field__input" v-model="editForm.phone" placeholder="Enter phone number" />
                        </div>
                        <div class="ct-field">
                            <label class="ct-field__label">Profile Photo</label>
                            <div class="ct-edit-avatar" v-if="editForm.existingImageUrl || editForm.name">
                                <img v-if="editForm.existingImageUrl" :src="editForm.existingImageUrl" />
                                <span v-else>{{ getInitials(editForm.name) }}</span>
                            </div>
                            <input type="file" class="ct-field__file" @change="handleEditFileUpload" accept="image/*" />
                            <img v-if="editForm.previewUrl" :src="editForm.previewUrl" class="ct-field__preview" />
                        </div>
                        <div class="ct-field">
                            <label class="ct-field__label">Notes <span class="ct-optional">(optional)</span></label>
                            <input type="text" class="ct-field__input" v-model="editForm.notes" placeholder="Add any notes" maxlength="100" />
                        </div>
                        <label class="ct-emergency-toggle">
                            <input type="checkbox" v-model="editForm.isEmergency" />
                            <div class="ct-emergency-toggle__body">
                                <span class="ct-emergency-toggle__title">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                    </svg>
                                    Emergency contact
                                </span>
                                <span class="ct-emergency-toggle__sub">Can always call/message even when restrictions are active</span>
                            </div>
                        </label>
                    </div>
                    <div class="ct-modal__footer">
                        <button class="ct-modal__cancel" @click="showEditModal = false">Cancel</button>
                        <button class="ct-modal__confirm" @click="updateContact()" :disabled="isUpdating">
                            <span v-if="isUpdating"><i class="fa fa-spinner fa-spin"></i></span>
                            <span v-else>Update Contact</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- ── Delete Modal ── -->
            <div class="ct-modal-overlay" v-if="showDeleteModal" @click.self="showDeleteModal = false">
                <div class="ct-modal ct-modal--small">
                    <div class="ct-modal__title" style="margin-bottom:8px;">Delete Contact?</div>
                    <div class="ct-modal__sub" style="margin-bottom:20px; font-size:13px; color:#6b7280;">This action cannot be undone.</div>
                    <div class="ct-modal__footer" style="padding:0;">
                        <button class="ct-modal__cancel" @click="showDeleteModal = false">Cancel</button>
                        <button class="ct-modal__confirm ct-modal__confirm--red" @click="deleteContact(selectedContactId)">Delete</button>
                    </div>
                </div>
            </div>

            <!-- ── Contact Requests Modal ── -->
            <div class="ct-modal-overlay" v-if="showRequestsModal" @click.self="showRequestsModal = false">
                <div class="ct-modal ct-modal--tall">
                    <div class="ct-modal__header">
                        <div class="ct-modal__header-icon ct-modal__header-icon--orange">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
                                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            </svg>
                        </div>
                        <div>
                            <div class="ct-modal__title">Contact Requests</div>
                            <div class="ct-modal__sub">{{ totalPendingRequests }} pending request{{ totalPendingRequests !== 1 ? 's' : '' }}</div>
                        </div>
                        <button class="ct-modal__close" @click="showRequestsModal = false">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Tabs -->
                    <div class="ct-tabs">
                        <button class="ct-tab" :class="{ 'ct-tab--active': requestsTab === 'add' }" @click="requestsTab = 'add'">
                            Add
                            <span class="ct-tab__badge ct-tab__badge--green" v-if="addRequests.length > 0">{{ addRequests.length }}</span>
                        </button>
                        <button class="ct-tab" :class="{ 'ct-tab--active': requestsTab === 'remove' }" @click="requestsTab = 'remove'">
                            Remove
                            <span class="ct-tab__badge ct-tab__badge--red" v-if="removeRequests.length > 0">{{ removeRequests.length }}</span>
                        </button>
                    </div>

                    <div class="ct-modal__scrollbody">
                        <div class="ct-notif-loader" v-if="requestsLoading">
                            <i class="fa fa-spinner fa-spin"></i>
                            <span>Loading...</span>
                        </div>

                        <!-- Add requests -->
                        <div v-else-if="requestsTab === 'add'">
                            <div class="ct-req-empty" v-if="addRequests.length === 0">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round"/>
                                    <circle cx="12" cy="7" r="4" stroke="#d1d5db" stroke-width="1.5"/>
                                </svg>
                                <span>No pending add requests</span>
                            </div>
                            <div class="ct-req-item" v-for="req in addRequests" :key="req._id">
                                <div class="ct-req-item__avatar ct-req-item__avatar--green">{{ getInitials(req.name) }}</div>
                                <div class="ct-req-item__body">
                                    <span class="ct-req-item__name">{{ req.name }}</span>
                                    <span class="ct-req-item__phone">{{ req.phone }}</span>
                                    <span class="ct-req-item__notes" v-if="req.notes">{{ req.notes }}</span>
                                </div>
                                <div class="ct-req-item__actions">
                                    <button class="ct-req-btn ct-req-btn--approve" @click="approveContact(req)" :disabled="req._processing">
                                        <i v-if="req._processing" class="fa fa-spinner fa-spin"></i>
                                        <svg v-else width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                    <button class="ct-req-btn ct-req-btn--reject" @click="rejectRequest(req._id)" :disabled="req._processing">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Remove requests -->
                        <div v-else>
                            <div class="ct-req-empty" v-if="removeRequests.length === 0">
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round"/>
                                    <circle cx="12" cy="7" r="4" stroke="#d1d5db" stroke-width="1.5"/>
                                </svg>
                                <span>No pending remove requests</span>
                            </div>
                            <div class="ct-req-item" v-for="req in removeRequests" :key="req._id">
                                <div class="ct-req-item__avatar ct-req-item__avatar--red">{{ getInitials(req.name) }}</div>
                                <div class="ct-req-item__body">
                                    <span class="ct-req-item__name">{{ req.name }}</span>
                                    <span class="ct-req-item__phone">{{ req.phone }}</span>
                                </div>
                                <div class="ct-req-item__actions">
                                    <button class="ct-req-btn ct-req-btn--approve-red" @click="approveContact(req)" :disabled="req._processing">
                                        <i v-if="req._processing" class="fa fa-spinner fa-spin"></i>
                                        <svg v-else width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                    <button class="ct-req-btn ct-req-btn--reject" @click="rejectRequest(req._id)" :disabled="req._processing">
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ── Settings Modal ── -->
            <div class="ct-modal-overlay" v-if="showSettingsModal" @click.self="showSettingsModal = false">
                <div class="ct-modal ct-modal--tall">
                    <div class="ct-modal__header">
                        <div class="ct-modal__header-icon ct-modal__header-icon--purple">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
                                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" stroke-width="1.8"/>
                            </svg>
                        </div>
                        <div>
                            <div class="ct-modal__title">Settings <span style="font-size:10px; background:#fef3c7; color:#92400e; padding:2px 7px; border-radius:20px; font-weight:600; margin-left:4px;">BETA</span></div>
                            <div class="ct-modal__sub">Contact &amp; communication settings</div>
                        </div>
                        <button class="ct-modal__close" @click="showSettingsModal = false">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="ct-modal__scrollbody" v-if="settingsLoaded">
                        <!-- Dialer disabled notice -->
                        <div class="ct-settings-banner" v-if="!settings.enableWingioDialer">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                                <path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                            </svg>
                            Settings only work when Wingio Dialer is enabled on the device.
                        </div>

                        <!-- Wingio Dialer -->
                        <div class="ct-settings-section">Wingio Dialer</div>
                        <div class="ct-settings-row">
                            <div class="ct-settings-row__info">
                                <span class="ct-settings-row__title">Enable Wingio Dialer &amp; SMS</span>
                                <span class="ct-settings-row__sub">Required for all contact and communication restrictions</span>
                            </div>
                            <label class="kid-action-switch">
                                <input type="checkbox" v-model="settings.enableWingioDialer" />
                                <span class="kid-action-switch__track"></span>
                            </label>
                        </div>

                        <div :class="{ 'ct-lockout': !settings.enableWingioDialer }">
                            <div class="ct-settings-section">Calls</div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Allow all incoming calls <span class="ct-badge ct-badge--warn">Not recommended</span></span>
                                    <span class="ct-settings-row__sub">Disabling restricts to approved contacts only</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.allowAllIncomingCall" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Allow all outgoing calls <span class="ct-badge ct-badge--warn">Not recommended</span></span>
                                    <span class="ct-settings-row__sub">Disabling restricts to approved contacts only</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.allowAllOutgoingCall" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>

                            <div class="ct-settings-section">SMS</div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Allow all incoming SMS <span class="ct-badge ct-badge--warn">Not recommended</span></span>
                                    <span class="ct-settings-row__sub">Disabling restricts to approved contacts only</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.allowAllIncomingSms" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Allow all outgoing SMS <span class="ct-badge ct-badge--warn">Not recommended</span></span>
                                    <span class="ct-settings-row__sub">Disabling restricts to approved contacts only</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.allowAllOutgoingSms" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Allow SMS In Sleep Mode<span class="ct-badge ct-badge--warn">Not recommended</span></span>
                                    <span class="ct-settings-row__sub">SMS will be available while in Sleep Mode.</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.allowMessagesInSleepMode" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>

                            <div class="ct-settings-section">Contact Requests</div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Auto-approve contact requests</span>
                                    <span class="ct-settings-row__sub">Approve or remove contacts without parent review</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.autoApproveContacts" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>

                            <div class="ct-settings-section">History &amp; Tracking</div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Call & SMS history tracking
                                        <!--<span class="ct-badge ct-badge--premium" v-if="!hasPremium">Premium</span>-->
                                    </span>
                                    <span class="ct-settings-row__sub">Incoming and outgoing call & SMS logs visible to parents</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.canReadSMSAndPhoneCall" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>
                            <!--<div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">SMS history tracking
                                        
                                        <span class="ct-badge ct-badge--red" v-if="settings.disableWingioSms">Requires Wingio SMS</span>
                                    </span>
                                    <span class="ct-settings-row__sub">SMS messages visible to parents — requires Wingio SMS</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" v-model="settings.enableSmsHistory" :disabled="settings.disableWingioSms || !settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>-->

                            <div class="ct-settings-section">Wingio SMS</div>
                            <div class="ct-settings-row">
                                <div class="ct-settings-row__info">
                                    <span class="ct-settings-row__title">Use Wingio SMS app</span>
                                    <span class="ct-settings-row__sub">Enables call and message monitoring on the device</span>
                                    <span class="ct-sms-warning" v-if="settings.disableWingioSms">SMS activity cannot be traced when Wingio is disabled.</span>
                                </div>
                                <label class="kid-action-switch">
                                    <input type="checkbox" :checked="!settings.disableWingioSms" @change="onWingioToggle" :disabled="!settings.enableWingioDialer" />
                                    <span class="kid-action-switch__track"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="ct-notif-loader" v-else>
                        <i class="fa fa-spinner fa-spin"></i><span>Loading settings...</span>
                    </div>

                    <div class="ct-modal__footer">
                        <button class="ct-modal__cancel" @click="showSettingsModal = false">Cancel</button>
                        <button class="ct-modal__confirm" @click="saveSettings()" :disabled="isSavingSettings">
                            <span v-if="isSavingSettings"><i class="fa fa-spinner fa-spin"></i></span>
                            <span v-else>Save Settings</span>
                        </button>
                    </div>
                </div>
            </div>

            <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
        </div>
    </div>
</template>

<script>

// Whole-word matches only, so "Mamadou" or "Dadson" won't trigger
const FAMILY_WORDS = new Set([
    // English
    'mom', 'mum', 'mommy', 'mummy', 'mama', 'mother', 'stepmom', 'stepmum', 'stepmother',
    'dad', 'daddy', 'dada', 'papa', 'pappa', 'pops', 'father', 'stepdad', 'stepfather',
    'parent', 'parents', 'guardian',
    'grandma', 'grandpa', 'granny', 'grandad', 'granddad', 'grandmother', 'grandfather',
    'gran', 'nan', 'nana', 'nanna',
    'aunt', 'auntie', 'aunty', 'uncle', 'brother', 'sister',
    // Common South Asian terms (Latin script)
    'amma', 'appa', 'ammi', 'abbu', 'abba', 'aai', 'baba', 'bapu', 'bapuji',
    'nani', 'nanu', 'dadi', 'dadu', 'bhai', 'bhaiya', 'didi',
    'masi', 'mausi', 'chacha', 'chachi', 'kaka', 'kaki', 'bua', 'fai'
]);

import KidHeader from "@/components/KidHeader.vue";
import KidFooter from "@/components/KidFooter.vue";
import ProfileService from "../../services/ProfileService";
import KidsService from "../../services/KidsService";

export default {
    name: "Contacts",
    components: { KidHeader, KidFooter },
    computed: {
        totalPendingRequests() { return this.addRequests.length + this.removeRequests.length; },
        isContactPickerSupported() { return 'contacts' in navigator && 'select' in navigator.contacts; }
    },
    data() {
        return {
            profileId: this.$route.query.profileId,
            serialNumber: this.$route.query.serialNumber,
            contacts: [],
            selectedContactId: null,
            hasChatAccess: false,
            hasPremium: false,
            isAdding: false,
            isUpdating: false,
            isDisabled: false,
            isSavingSettings: false,
            isCopying: false,
            importing: false,
            settingsLoaded: false,
            wingioDialerLoaded: false,
            addRequests: [],
            removeRequests: [],
            requestsLoading: false,
            requestsTab: 'add',
            // Modal states
            showAddModal: false,
            showEditModal: false,
            showDeleteModal: false,
            showRequestsModal: false,
            showSettingsModal: false,
            addForm: { name: "", phone: "", notes: "", isEmergency: false, emergencyTouched: false, autoDetected: false, imagePayload: null, previewUrl: null },
            editForm: { id: null, name: "", phone: "", notes: "", isEmergency: false, emergencyTouched: false, autoDetected: false, existingImageUrl: "", imagePayload: null, previewUrl: null },
            settings: { enableWingioDialer: true, allowAllIncomingCall: false, allowAllOutgoingCall: false, allowAllIncomingSms: false, allowMessagesInSleepMode: false, allowAllOutgoingSms: false, autoApproveContacts: false, enableCallHistory: false, enableSmsHistory: false, disableWingioSms: false, canReadSMSAndPhoneCall: false },
            copyForm: { fromProfileId: "", toProfileId: "" },
            allDevices: [],
        };
    },
    methods: {
        handleAddFileUpload(e) { const file = e.target.files[0]; if (!file) return; this.addForm.imagePayload = file; this.addForm.previewUrl = URL.createObjectURL(file); },
        handleEditFileUpload(e) { const file = e.target.files[0]; if (!file) return; this.editForm.imagePayload = file; this.editForm.previewUrl = URL.createObjectURL(file); },
        openAddModal() { this.addForm = { name: "", phone: "", notes: "", isEmergency: false, emergencyTouched: false, autoDetected: false, imagePayload: null, previewUrl: null }; this.showAddModal = true; },
        openEditModal(contact) { this.editForm = { id: contact._id, name: contact.name || "", phone: contact.phone || "", notes: contact.notes || "", isEmergency: contact.isEmergency || false, emergencyTouched: false, autoDetected: false, existingImageUrl: contact.imageUrl || "", imagePayload: null, previewUrl: null }; this.showEditModal = true; },
        openDeleteModal(id) { this.selectedContactId = id; this.showDeleteModal = true; },
        async openSettingsModal() { this.settingsLoaded = false; this.showSettingsModal = true; await this.loadSettings(); },
        async openRequestsModal() { this.requestsTab = 'add'; this.showRequestsModal = true; await this.loadContactRequests(); },
        async getContacts() {
            try { 
            const res = await ProfileService.listContact({ profileId: this.profileId, serialNumber: this.serialNumber });
            this.contacts = res.data.data; 
            this.hasChatAccess = res.data.hasChatAccess; 
            this.hasPremium = res.data.hasPremium || false; }
            catch (e) { this.$toast.error(e.response?.data?.respones_msg || "Failed to load contacts"); }
        },
        async addContact() {
            if (!this.addForm.name || !this.addForm.phone) { this.$toast.error("Name and phone number are required."); return; }
            this.isAdding = true;
            const fd = new FormData();
            fd.append("profile_id", this.profileId); fd.append("serialNumber", this.serialNumber); fd.append("name", this.addForm.name); fd.append("phone", this.addForm.phone); fd.append("notes", this.addForm.notes); fd.append("isEmergency", this.addForm.isEmergency);
            if (this.addForm.imagePayload) fd.append("image", this.addForm.imagePayload);
            try { await ProfileService.addContact(fd); this.showAddModal = false; this.getContacts(); this.applyPolicy(); }
            catch (e) { this.$toast.error(e.response?.data?.respones_msg || "Failed to add contact"); }
            finally { this.isAdding = false; }
        },
        async updateContact() {
            if (!this.editForm.name || !this.editForm.phone) { this.$toast.error("Name and phone number are required."); return; }
            this.isUpdating = true;
            const fd = new FormData();
            fd.append("id", this.editForm.id); fd.append("profile_id", this.profileId); fd.append("serialNumber", this.serialNumber); fd.append("name", this.editForm.name); fd.append("phone", this.editForm.phone); fd.append("notes", this.editForm.notes); fd.append("isEmergency", this.editForm.isEmergency);
            if (this.editForm.imagePayload) fd.append("image", this.editForm.imagePayload);
            try { await ProfileService.addContact(fd); this.showEditModal = false; this.getContacts(); this.applyPolicy(); }
            catch (e) { this.$toast.error(e.response?.data?.respones_msg || "Failed to update contact"); }
            finally { this.isUpdating = false; }
        },
        async deleteContact(id) {
            this.showDeleteModal = false;
            try { await ProfileService.deleteContact({ id, serialNumber: this.serialNumber }); this.getContacts(); this.applyPolicy(); }
            catch (e) { this.$toast.error(e.response?.data?.respones_msg || "Failed to delete contact"); }
        },
        async loadContactRequests() {
            this.requestsLoading = true;
            try { const res = await ProfileService.listContactRequests({ profileId: this.profileId, serialNumber: this.serialNumber }); this.addRequests = (res.data.addRequests || []).map(r => ({ ...r, _processing: false })); this.removeRequests = (res.data.removeRequests || []).map(r => ({ ...r, _processing: false })); if (this.addRequests.length === 0 && this.removeRequests.length > 0) this.requestsTab = 'remove'; }
            catch (e) { this.$toast.error("Failed to load contact requests"); }
            finally { this.requestsLoading = false; }
        },
        async rejectRequest(id) {
            let data = { profileId: this.profileId, serialNumber: this.serialNumber, id };
            await KidsService.rejectRequest(data)
            .then(() => { this.showRequestsModal = false; this.getContacts(); ProfileService.listContactRequests({ profileId: this.profileId, serialNumber: this.serialNumber }).then(res => { this.addRequests = (res.data.addRequests || []).map(r => ({ ...r, _processing: false })); this.removeRequests = (res.data.removeRequests || []).map(r => ({ ...r, _processing: false })); }).catch(() => {}); })
            .catch((e) => { this.$toast.error(e.response.data.respones_msg); });
        },
        approveContact(item) {
            KidsService.approveContact({ profileId: this.profileId, serialNumber: this.serialNumber, id: item._id })
            .then(() => { this.showRequestsModal = false; this.getContacts(); this.applyPolicy(); ProfileService.listContactRequests({ profileId: this.profileId, serialNumber: this.serialNumber }).then(res => { this.addRequests = (res.data.addRequests || []).map(r => ({ ...r, _processing: false })); this.removeRequests = (res.data.removeRequests || []).map(r => ({ ...r, _processing: false })); }).catch(() => {}); })
            .catch((e) => { this.$toast.error(e.response.data.respones_msg); });
        },
        async loadSettings() {
            try { const res = await ProfileService.getContactSettings({ profileId: this.profileId, serialNumber: this.serialNumber }); this.settings = { ...this.settings, ...res.data.data }; this.settingsLoaded = true; }
            catch (e) { this.$toast.error("Failed to load settings"); this.settingsLoaded = true; }
        },
        async saveSettings() {
            this.isSavingSettings = true;
            try { await ProfileService.updateContactSettings({ profileId: this.profileId, serialNumber: this.serialNumber, ...this.settings }); this.showSettingsModal = false; this.loadSettings(); this.getContacts(); this.applyPolicy(); }
            catch (e) { this.$toast.error(e.response?.data?.respones_msg || "Failed to save settings"); }
            finally { this.isSavingSettings = false; }
        },
        onWingioToggle(e) { this.settings.disableWingioSms = !e.target.checked; if (this.settings.disableWingioSms) this.settings.enableSmsHistory = false; },
        async loadWingioDialerStatus() {
            try { const res = await ProfileService.getContactSettings({ profileId: this.profileId, serialNumber: this.serialNumber }); this.settings.enableWingioDialer = res.data.data.enableWingioDialer ?? true; }
            catch (_) {} finally { this.wingioDialerLoaded = true; }
        },
        applyPolicy() { ProfileService.applyPolicy({ profile_id: this.profileId, serialNumber: this.serialNumber }).catch(() => {}); },
        getInitials(name) { if (!name) return "?"; const parts = name.trim().split(" "); if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase(); return name.substring(0, 2).toUpperCase(); },
        async importFromPhone() {
            if (!this.isContactPickerSupported) { this.$toast.error('Contact import not supported on this device'); return; }
            this.importResults = { success: [], failed: [] };
            try {
                const selectedContacts = await navigator.contacts.select(['name', 'tel', 'icon', 'email'], { multiple: true });
                if (!selectedContacts.length) { this.$toast.info('No contacts selected'); return; }
                this.importing = true;
                for (const contact of selectedContacts) {
                    const name = contact.name?.[0]; const phone = contact.tel?.[0]; const email = contact.email?.[0];
                    if (!name || !phone) { this.importResults.failed.push({ name: name || 'Unknown', reason: 'Missing name or phone number' }); continue; }
                    try { await this.addImportedContact(name, phone, email); this.importResults.success.push(name); }
                    catch (err) { this.importResults.failed.push({ name, reason: err?.response?.data?.respones_msg || 'Failed to add contact' }); }
                }
                this.importing = false; this.getContacts(); this.applyPolicy(); this.showImportSummary();
            } catch (err) { this.$toast.error(err.message || 'Failed to import contacts'); }
        },
        async addImportedContact(name, phone, email) { const fd = new FormData(); fd.append('profile_id', this.profileId); fd.append('serialNumber', this.serialNumber); fd.append('name', name); fd.append('phone', phone); fd.append('email', email); fd.append('notes', ""); return await ProfileService.addContact(fd); },
        showImportSummary() {
            const sc = this.importResults.success.length; const fc = this.importResults.failed.length;
            if (sc) this.$toast.success(`Imported ${sc} contact(s) successfully`);
            if (fc) this.$toast.error(`Failed to import ${fc} contact(s)`);
        },
        isFamilyName(name) {
            if (!name) return false;
            const words = name.toLowerCase().split(/[^\p{L}\p{M}]+/u).filter(Boolean);
            return words.some(w => FAMILY_WORDS.has(w));
        },
        onAddNameInput(name) {
            if (this.addForm.emergencyTouched) return;        // parent chose manually, respect it
            const match = this.isFamilyName(name);
            this.addForm.isEmergency = match;
            this.addForm.autoDetected = match;
        },
        onEditNameInput(name) {
            // Edit: only ever turns ON, never silently removes emergency status
            if (this.editForm.emergencyTouched || this.editForm.isEmergency) return;
            if (this.isFamilyName(name)) {
                this.editForm.isEmergency = true;
                this.editForm.autoDetected = true;
            }
        },
        markEmergencyTouched(form) {
            form.emergencyTouched = true;
            form.autoDetected = false;
        },
    },
    beforeMount() {
        this.getContacts(); this.loadWingioDialerStatus();
        ProfileService.listContactRequests({ profileId: this.$route.query.profileId, serialNumber: this.$route.query.serialNumber })
        .then(res => { this.addRequests = (res.data.addRequests || []).map(r => ({ ...r, _processing: false })); this.removeRequests = (res.data.removeRequests || []).map(r => ({ ...r, _processing: false })); }).catch(() => {});
    },
};
</script>

<style scoped>
/* ── Back nav ── */
.req-back { padding: 12px 14px 8px; width: 100%; text-align: left; }
.req-back__link { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: #374151; text-decoration: none; -webkit-tap-highlight-color: transparent; }

/* ── Page header ── */
.ct-page-header { width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 4px 14px 12px; }
.ct-page-header__title { font-size: 20px; font-weight: 700; color: #111; margin: 0 0 2px; }
.ct-page-header__sub { font-size: 12px; color: #6b7280; margin: 0; }
.ct-page-header__actions { display: flex; align-items: center; gap: 8px; }

.ct-add-btn {
    display: inline-flex; align-items: center; gap: 5px;
    height: 36px; padding: 0 14px;
    background: #2563eb; color: #fff;
    border: none; border-radius: 10px;
    font-size: 13px; font-weight: 600; cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.ct-add-btn:active { opacity: 0.85; }
.ct-add-btn--full { width: 100%; justify-content: center; height: 44px; border-radius: 12px; margin-top: 16px; }

.ct-requests-btn {
    position: relative; width: 36px; height: 36px; border-radius: 10px;
    border: 0.5px solid #e5e7eb; background: #f9fafb;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #374151; -webkit-tap-highlight-color: transparent;
}
.ct-requests-btn__badge {
    position: absolute; top: -4px; right: -4px;
    min-width: 16px; height: 16px; padding: 0 4px;
    background: #dc2626; color: #fff;
    font-size: 9px; font-weight: 700; border-radius: 20px;
    display: flex; align-items: center; justify-content: center;
    border: 1.5px solid #fff;
}

/* ── Dialer banner ── */
.ct-dialer-banner {
    display: flex; align-items: flex-start; gap: 10px;
    margin: 0 14px 8px; padding: 12px 14px;
    background: #fff5f5; border: 0.5px solid #fecaca;
    border-radius: 12px;
}
.ct-dialer-banner__icon {
    width: 32px; height: 32px; border-radius: 8px;
    background: #fee2e2; color: #dc2626;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
}
.ct-dialer-banner__body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.ct-dialer-banner__title { font-size: 13px; font-weight: 600; color: #dc2626; }
.ct-dialer-banner__sub { font-size: 11px; color: #b91c1c; }
.ct-dialer-banner__link { color: #991b1b; font-weight: 600; text-decoration: underline; }

/* ── Quick actions ── */
.ct-quick-actions {
    display: flex; gap: 8px; padding: 0 14px 12px;
    overflow-x: auto; scrollbar-width: none;
    width: 100%;
    justify-content: center;
}
.ct-quick-actions::-webkit-scrollbar { display: none; }

.ct-quick-btn {
    display: flex; flex-direction: column; align-items: center; gap: 5px;
    min-width: 58px; padding: 10px 8px;
    background: #fff; border: 0.5px solid #e5e7eb;
    border-radius: 12px; cursor: pointer; position: relative;
    -webkit-tap-highlight-color: transparent; flex-shrink: 0;
}
.ct-quick-btn:active { background: #f9fafb; }
.ct-quick-btn span { font-size: 10px; font-weight: 600; color: #374151; white-space: nowrap; }
.ct-quick-btn:disabled { opacity: 0.6; cursor: not-allowed; }

.ct-quick-btn__icon {
    width: 32px; height: 32px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
}
.ct-quick-btn__icon--blue { background: #dbeafe; color: #1d4ed8; }
.ct-quick-btn__icon--green { background: #dcfce7; color: #16a34a; }
.ct-quick-btn__icon--orange { background: #ffedd5; color: #ea580c; }
.ct-quick-btn__icon--purple { background: #ede9fe; color: #7c3aed; }
.ct-quick-btn__icon--teal { background: #ccfbf1; color: #0d9488; }

.ct-quick-btn__badge {
    position: absolute; top: 4px; right: 4px;
    min-width: 14px; height: 14px; padding: 0 3px;
    background: #dc2626; color: #fff;
    font-size: 8px; font-weight: 700; border-radius: 20px;
    display: flex; align-items: center; justify-content: center;
    border: 1.5px solid #fff;
}

/* ── Section label ── */
.ct-section-label { font-size: 11px; font-weight: 700; color: #6b7280; text-transform: uppercase; letter-spacing: 0.6px; padding: 4px 14px 6px; }

/* ── Lockout ── */
.ct-lockout { opacity: 0.45; pointer-events: none; user-select: none; }

/* ── Empty ── */
.ct-empty { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 48px 14px; text-align: center; }
.ct-empty__icon { width: 72px; height: 72px; border-radius: 50%; background: #f3f4f6; display: flex; align-items: center; justify-content: center; margin-bottom: 8px; }
.ct-empty__title { font-size: 16px; font-weight: 700; color: #111; }
.ct-empty__sub { font-size: 13px; color: #6b7280; }

/* ── Contact list ── */
.ct-list { display: flex; flex-direction: column; gap: 6px; padding: 0 14px; }

.ct-contact-card {
    display: flex; align-items: center; gap: 12px;
    background: #fff; border-radius: 14px;
    border: 0.5px solid #e5e7eb; padding: 12px 12px;
}
.ct-contact-card--emergency { background: #fffbeb; border-color: #fde68a; }

.ct-contact-card__avatar {
    width: 42px; height: 42px; border-radius: 11px;
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    color: #1e40af; display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700; flex-shrink: 0; overflow: hidden;
}
.ct-contact-card__avatar img { width: 100%; height: 100%; object-fit: cover; }

.ct-contact-card__body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.ct-contact-card__name-row { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.ct-contact-card__name { font-size: 14px; font-weight: 600; color: #111; }
.ct-contact-card__phone { font-size: 12px; color: #2563eb; text-decoration: none; font-weight: 500; }
.ct-contact-card__notes { font-size: 11px; color: #9ca3af; }

.ct-emergency-pill {
    display: inline-flex; align-items: center; gap: 3px;
    padding: 2px 7px; border-radius: 20px;
    background: #fee2e2; color: #991b1b;
    font-size: 10px; font-weight: 600;
}

.ct-contact-card__actions { display: flex; gap: 6px; flex-shrink: 0; }
.ct-contact-btn {
    width: 32px; height: 32px; border-radius: 8px; border: none;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; -webkit-tap-highlight-color: transparent;
}
.ct-contact-btn--edit { background: #eff6ff; color: #2563eb; }
.ct-contact-btn--edit:active { background: #dbeafe; }
.ct-contact-btn--delete { background: #fff5f5; color: #dc2626; }
.ct-contact-btn--delete:active { background: #fee2e2; }

/* ── Modals ── */
.ct-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 300; display: flex; align-items: flex-end; justify-content: center; }
.ct-modal {
    background: #fff; border-radius: 20px 20px 0 0;
    width: 100%; max-width: 575px;
    padding: 20px 16px 32px;
    animation: slideUp 0.25s ease;
    max-height: 92dvh; display: flex; flex-direction: column;
    text-align: left;
}
.ct-modal--small { max-height: 280px; }
.ct-modal--tall { max-height: 88dvh; text-align: left; }
@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }

.ct-modal__header { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 16px; flex-shrink: 0; }
.ct-modal__header-icon { width: 38px; height: 38px; border-radius: 10px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.ct-modal__header-icon--blue { background: #dbeafe; color: #1d4ed8; }
.ct-modal__header-icon--purple { background: #ede9fe; color: #7c3aed; }
.ct-modal__header-icon--orange { background: #ffedd5; color: #ea580c; }
.ct-modal__close { margin-left: auto; width: 32px; height: 32px; border-radius: 8px; border: none; background: #f3f4f6; color: #6b7280; display: flex; align-items: center; justify-content: center; cursor: pointer; flex-shrink: 0; }
.ct-modal__title { font-size: 16px; font-weight: 700; color: #111; margin-bottom: 2px; }
.ct-modal__sub { font-size: 12px; color: #6b7280; }

.ct-modal__body { display: flex; flex-direction: column; gap: 12px; overflow-y: auto; scrollbar-width: none; flex: 1; min-height: 0; padding-bottom: 4px; }
.ct-modal__body::-webkit-scrollbar { display: none; }
.ct-modal__scrollbody { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: none; }
.ct-modal__scrollbody::-webkit-scrollbar { display: none; }

.ct-modal__footer { display: flex; gap: 10px; margin-top: 16px; flex-shrink: 0; }
.ct-modal__cancel { flex: 1; height: 44px; border-radius: 12px; border: 0.5px solid #e5e7eb; background: #f3f4f6; font-size: 14px; font-weight: 600; color: #374151; cursor: pointer; }
.ct-modal__confirm { flex: 1; height: 44px; border-radius: 12px; border: none; background: #2563eb; color: #fff; font-size: 14px; font-weight: 600; cursor: pointer; }
.ct-modal__confirm--red { background: #dc2626; }
.ct-modal__confirm:disabled, .ct-modal__cancel:disabled { opacity: 0.6; cursor: not-allowed; }

/* ── Fields ── */
.ct-field { display: flex; flex-direction: column; gap: 5px; }
.ct-field__label { font-size: 12px; font-weight: 600; color: #374151; }
.ct-field__input { width: 100%; height: 42px; border: 0.5px solid #e5e7eb; border-radius: 10px; padding: 0 12px; font-size: 14px; color: #111; background: #fafafa; outline: none; box-sizing: border-box; }
.ct-field__input:focus { border-color: #2563eb; background: #fff; }
.ct-field__input--textarea { height: auto; padding: 10px 12px; resize: none; }
.ct-field__file { font-size: 13px; color: #374151; }
.ct-field__preview { width: 60px; height: 60px; border-radius: 10px; object-fit: cover; margin-top: 6px; border: 0.5px solid #e5e7eb; }

.ct-edit-avatar { width: 48px; height: 48px; border-radius: 10px; background: linear-gradient(135deg, #dbeafe, #bfdbfe); color: #1e40af; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; overflow: hidden; margin-bottom: 6px; }
.ct-edit-avatar img { width: 100%; height: 100%; object-fit: cover; }

.ct-emergency-toggle { display: flex; align-items: flex-start; gap: 10px; background: #fffbeb; border: 0.5px solid #fde68a; border-radius: 10px; padding: 12px; cursor: pointer; }
.ct-emergency-toggle input { margin-top: 1px; flex-shrink: 0; accent-color: #f59e0b; }
.ct-emergency-toggle__body { display: flex; flex-direction: column; gap: 3px; }
.ct-emergency-toggle__title { display: flex; align-items: center; gap: 5px; font-size: 13px; font-weight: 600; color: #92400e; }
.ct-emergency-toggle__sub { font-size: 11px; color: #b45309; line-height: 1.4; }

/* ── Tabs ── */
.ct-tabs { display: flex; border-bottom: 0.5px solid #f3f4f6; margin-bottom: 4px; flex-shrink: 0; }
.ct-tab { flex: 1; padding: 10px; border: none; background: none; font-size: 13px; font-weight: 600; color: #6b7280; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 6px; border-bottom: 2px solid transparent; margin-bottom: -1px; -webkit-tap-highlight-color: transparent; }
.ct-tab--active { color: #2563eb; border-bottom-color: #2563eb; }
.ct-tab__badge { display: inline-flex; align-items: center; justify-content: center; min-width: 16px; height: 16px; padding: 0 4px; border-radius: 20px; font-size: 9px; font-weight: 700; }
.ct-tab__badge--green { background: #dcfce7; color: #166534; }
.ct-tab__badge--red { background: #fee2e2; color: #991b1b; }

/* ── Request items ── */
.ct-req-item { display: flex; align-items: center; gap: 10px; padding: 12px 0; border-bottom: 0.5px solid #f9fafb; }
.ct-req-item:last-child { border-bottom: none; }
.ct-req-item__avatar { width: 36px; height: 36px; border-radius: 9px; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0; }
.ct-req-item__avatar--green { background: #dcfce7; color: #166534; }
.ct-req-item__avatar--red { background: #fee2e2; color: #991b1b; }
.ct-req-item__body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.ct-req-item__name { font-size: 13px; font-weight: 600; color: #111; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ct-req-item__phone { font-size: 12px; color: #2563eb; }
.ct-req-item__notes { font-size: 11px; color: #9ca3af; }
.ct-req-item__actions { display: flex; gap: 6px; flex-shrink: 0; }

.ct-req-btn { width: 32px; height: 32px; border-radius: 8px; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; -webkit-tap-highlight-color: transparent; }
.ct-req-btn--approve { background: #dcfce7; color: #16a34a; }
.ct-req-btn--approve-red { background: #fee2e2; color: #dc2626; }
.ct-req-btn--reject { background: #f3f4f6; color: #6b7280; }
.ct-req-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.ct-req-empty { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 32px 16px; color: #9ca3af; font-size: 13px; }

/* ── Settings ── */
.ct-settings-banner { display: flex; align-items: center; gap: 8px; background: #eff6ff; border: 0.5px solid #bfdbfe; border-radius: 10px; padding: 10px 12px; font-size: 12px; color: #1d4ed8; margin-bottom: 8px; }
.ct-settings-section { font-size: 10px; font-weight: 700; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.6px; padding: 12px 0 4px; border-top: 0.5px solid #f3f4f6; margin-top: 4px; }
.ct-settings-section:first-child { border-top: none; margin-top: 0; padding-top: 0; }
.ct-settings-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 0; border-bottom: 0.5px solid #f9fafb; }
.ct-settings-row:last-child { border-bottom: none; }
.ct-settings-row__info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.ct-settings-row__title { font-size: 13px; font-weight: 600; color: #111; display: flex; align-items: center; gap: 5px; flex-wrap: wrap; line-height: 1.3; }
.ct-settings-row__sub { font-size: 11px; color: #6b7280; line-height: 1.4; }

.ct-badge { display: inline-flex; padding: 2px 6px; border-radius: 20px; font-size: 10px; font-weight: 600; white-space: nowrap; }
.ct-badge--warn { background: #fef3c7; color: #92400e; }
.ct-badge--premium { background: #fef9c3; color: #854d0e; }
.ct-badge--red { background: #fee2e2; color: #991b1b; }

.ct-sms-warning { display: block; margin-top: 5px; padding: 6px 9px; background: #fff5f5; border: 0.5px solid #fecaca; border-radius: 7px; font-size: 11px; color: #b91c1c; line-height: 1.4; }

/* ── Switch ── */
.kid-action-switch { position: relative; display: inline-flex; width: 38px; height: 20px; cursor: pointer; margin: 0; flex-shrink: 0; }
.kid-action-switch input { opacity: 0; width: 0; height: 0; position: absolute; }
.kid-action-switch__track { position: absolute; inset: 0; background: #d1d5db; border-radius: 999px; transition: background 0.2s; }
.kid-action-switch__track::after { content: ''; position: absolute; top: 3px; left: 3px; width: 14px; height: 14px; background: white; border-radius: 50%; transition: transform 0.2s; }
.kid-action-switch input:checked + .kid-action-switch__track { background: #2563eb; }
.kid-action-switch input:checked + .kid-action-switch__track::after { transform: translateX(18px); }
.kid-action-switch input:disabled + .kid-action-switch__track { opacity: 0.4; cursor: not-allowed; }

/* ── Loader ── */
.ct-notif-loader { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 32px 16px; color: #9ca3af; font-size: 13px; }

/* ── Last updated ── */
.last-updated { display: flex; align-items: center; justify-content: center; gap: 5px; font-size: 12px; color: #9ca3af; }

/* ── Mobile footer clearance ── */
@media (max-width: 575px) {
    .ct-modal { padding-bottom: calc(60px + env(safe-area-inset-bottom, 16px)); }
}

button:focus { outline: none; }

/* ── Pinned emergency row ── */
.ct-emergency-pinned {
    flex-shrink: 0;
    display: flex; align-items: center; gap: 10px;
    margin-top: 12px; padding: 10px 12px;
    background: #f9fafb; border: 0.5px solid #e5e7eb; border-radius: 12px;
    transition: background 0.2s, border-color 0.2s;
}
.ct-emergency-pinned--on { background: #fffbeb; border-color: #fde68a; }
.ct-emergency-pinned__icon {
    width: 32px; height: 32px; border-radius: 9px;
    background: #fef3c7; color: #b45309;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ct-emergency-pinned__text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.ct-emergency-pinned__title { font-size: 13px; font-weight: 600; color: #111; }
.ct-emergency-pinned__sub { font-size: 11px; color: #6b7280; line-height: 1.35; }
.ct-emergency-pinned--on .ct-emergency-pinned__sub { color: #92400e; }
.kid-action-switch--amber input:checked + .kid-action-switch__track { background: #f59e0b; }

/* ── Compact photo row ── */
.ct-optional { font-weight: 500; color: #9ca3af; }
.ct-photo-row { display: flex; align-items: center; gap: 10px; }
.ct-photo-row__thumb {
    width: 44px; height: 44px; border-radius: 11px; flex-shrink: 0; overflow: hidden;
    background: linear-gradient(135deg, #dbeafe, #bfdbfe); color: #1e40af;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700;
}
.ct-photo-row__thumb img { width: 100%; height: 100%; object-fit: cover; }
.ct-photo-row__btn {
    margin: 0; padding: 8px 12px;
    border: 0.5px solid #e5e7eb; border-radius: 10px; background: #f9fafb;
    font-size: 12px; font-weight: 600; color: #374151; cursor: pointer;
}
.ct-sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); }
</style>